<template>
    <div class="footer">
        <div class="link-box">
            <a :href="privacyLink" target="_blank">{{ $t('txtPrivacy') }}</a>
            <span>|</span>
            <a :href="$t('linkImpress')" target="_blank">{{ $t('txtImpress') }}</a>
        </div>
        <app-lng-switch></app-lng-switch>
    </div>
</template>

<script>
    import AppLngSwitch from './AppLngSwitch'

    export default {
      computed: {
        privacyLink: function () {
          return this.$store.state.hotelData.hotel.urls.privacy
        }
      },
      components: {
        AppLngSwitch
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';
    .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2px;
        //background: linear-gradient(to bottom, rgba(204,204,204,0.9) 0%,rgba(204,204,204,0.2) 95%);
    }
    .link-box * {
        color: #888;
    }
    .link-box a {
        padding: 3px;
        margin: 3px;
        opacity: 0.8;
        text-decoration: none;
    }
    .link-box {
        margin-left: 2px;
    }
    .link-box:last-child {
        margin-right: 0;
    }

</style>    


// WEBPACK FOOTER //
// src/components/AppFooter.vue